<template>
  <Form 
    :d_form='form'
    :d_se_pengeluaran='se_pengeluaran'
    :d_lkp_negara='lkp_negara'
    :d_se_katalog='se_katalog'
    v-if="id > 0 && load == 4"
  /> 
  <Form 
    :d_form='form'
    :d_se_pengeluaran='se_pengeluaran'
    :d_lkp_negara='lkp_negara'
    :d_se_katalog='se_katalog'
    v-else-if="id == 0 && load == 3"
  /> 
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'
import Form from "./_From.vue";

export default {
  extends: ZResource,
  components: {
    Form
  },
  props: {
    id: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'se.adhoc',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Pengurusan Semen Beku', route: '/se' },
        { label: 'Pemungutan Pendaftaran Ad Hoc', route: '/se/adhoc' },
      ],
      title : 'Tambah Baka Jantan',
      form : {
        id : 0,
        tarikh : '',
        no_batch: '',
        tarikh_pengeluaran : '',
        id_ternakan : '',
        nama_ternakan: '',
        baka: '',
        negara : '',
        jumlah_straw: '',
        se_katalog_id: '',
        nama_pengeluar_s: '',
        kepemilikan:1,
        adhoc : 1,
        harga:0,
        hantar: 2
      },
      form1:[],
      se_pengeluaran : [],
      lkp_negara: [],
      negeri: [],
      se_katalog: [],
      load : 0
      
      
    }
  },
  methods: {
    
    getGetnoBatch(){
      this.$zcomm.get(this.api_service + 'se_pendaftaran/get', {}).then(res => {
        this.se_pengeluaran = res
        this.load = this.load + 1
      })
    },
 
    getData(){
      if(this.id > 0){
        this.$zcomm.get(this.api_service + 'se_pendaftaran/show/'+this.id, {}).then(res => {
          this.form = res
          this.load = this.load + 1

        })
      }
    },
    getNegara(){
      this.$zcomm.get(this.api_service + 'lookup/negara', {}).then(res => {
        this.lkp_negara = res
        this.load = this.load + 1
      })
    },
    getKatalog(){
      this.$zcomm.get(this.api_service + 'lookup/id_ternakan_hoc/'+this.form.adhoc, {}).then(res => {
        this.se_katalog = res
        this.load = this.load + 1
      })
   },
  
  },

  watch: {

  },
  mounted() {
    this.getData();
    this.getNegara();
    this.getKatalog();
    this.getGetnoBatch()
    
  }
    
}
</script>
